var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { attrs: { gutter: 10 } },
    [
      _c("el-col", { attrs: { xs: 0, sm: 6, md: 8, lg: 8, xl: 8 } }, [
        _vm._v(" "),
      ]),
      _vm._v(" "),
      _c("el-col", { attrs: { xs: 24, sm: 12, md: 8, lg: 8, xl: 8 } }, [
        _c("div", { staticStyle: { "margin-top": "15px" } }, [
          _c("div", [
            _c(
              "h1",
              {
                staticStyle: {
                  "font-size": "22px",
                  "line-height": "1.4",
                  "margin-bottom": "14px",
                  "font-weight": "500",
                  "margin-left": "20px",
                },
              },
              [_vm._v("Disclaimer")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-left": "20px" } }, [
            _c("span", { staticClass: "subtitle" }, [_vm._v("SITCLINE")]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  color: "#576B95",
                  display: "inline-block",
                  "vertical-align": "middle",
                  "font-size": "15px",
                },
              },
              [_vm._v("海丰集运")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "subtitle" }, [
              _vm._v("2025年03月03日 09：51"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "center", margin: "15px" } },
            [
              _c("img", {
                staticStyle: { width: "100%", "max-width": "500px" },
                attrs: { src: require("@/assets/img/logoPro.png") },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contentMain", staticStyle: { margin: "15px" } },
            [
              _c("div", [
                _c("p", { domProps: { innerHTML: _vm._s(_vm.termContentEn) } }),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("p", { domProps: { innerHTML: _vm._s(_vm.termContentZh) } }),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("el-col", { attrs: { xs: 0, sm: 6, md: 8, lg: 8, xl: 8 } }, [
        _vm._v(" "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }